import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiInput = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { biData, innerRef, stopPropagation } = _param, props = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation"
    ]);
    const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
    return /*#__PURE__*/ React.createElement("input", _object_spread_props(_object_spread({}, props), {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
            // TODO: Replace with `setRefs` utility, but we need to move that out of da-ds first
            if (!ref) {
                return;
            }
            if (typeof ref === 'function') {
                ref(node);
                return;
            }
            ref.current = node;
        }
    }));
});
BiInput.displayName = 'BiInput';
export default BiInput;
